module.exports = __webpack_public_path__ + "img/42.79d2a325.webp";